module.exports = __webpack_public_path__ + "img/Jump Casting69.32c40677.jpg";